const nps = {
  nps: {
    npsBreakdown: 'Suddivisione NPS',
    npsScore: 'Punteggio NPS',
    npsSpread: 'Diffusione NPS',
    npsDashboard: 'DASHBOARD NPS',
    npsDetails: 'Dettagli NPS',
    npsTrend: 'Tendenza NPS',
    verbatims: 'Testualmente',
    timePeriod: 'Periodo di tempo: ',
    to: 'a',
    pastMonths: 'Ultimi %{month} mesi',
    ratingType: 'Tipo dai valutazione',
    systemId: 'ID sistema',
    systemName: 'Nome del sistema',
    rating: 'Valutazione',
    comments: 'Commenti',
    all: 'Tutti',
    promoter: 'Promotore',
    promoters: 'Promotori',
    detractor: 'Detrattore',
    detractors: 'Detrattori',
    passive: 'Passivo',
    noData: 'Nessun dato disponibile',
    npsDashboardTooltip: {
      whatIs: "Che cos'è il Net Promoter Score?",
      npsDefine:
        "Il Net Promoter Score è un indice che spazia da -100 a 100 e che misura la volontà dei clienti a raccomandare l'azienda ad altri. Viene usato come indicatore per misurare la soddisfazione dei clienti.",
      questionIs:
        'La domanda viene formulata così: "Su una scala da 0 a 10, con quale probabilità raccomanderebbe la nostra organizzazione a un amico o un collega?" Il numero scelto dal cliente lo classifica in una delle seguenti categorie: "Detrattori," "Passivi" e "Promotori." Suddivisione punteggio: 0 - 6: Detrattori, 7 - 8: Passivi, 9 - 10: Promotori',
      determined:
        'Il Net Promoter Score (NPS) viene determinato sottraendo la percentuale dei clienti detrattori dalla percentuale dei promotori. Ne deriva un punteggio compreso tra -100 e 100 denominato Net Promoter Score.',
      how: 'In che modo Enphase determina il NPS per te?',
      shownBelow:
        "Enphase chiede ai proprietari di casa di fornire una valutazione nell'app mobile di Enlighten Mobile, come mostrato nelle schermate seguenti. In base alle valutazioni fornite, il NPS viene determinato come descritto in precedenza."
    },
    timePeriodTooltip:
      'Il periodo temporale predefinito è degli ultimi 13 mesi. Se il punteggio NPS non è disponibile per gli ultimi 13 mesi, allora il punteggio è incluso dal primo mese disponibile.',
    verbatimsTooltip:
      'Tutti i commenti visualizzati qui sono stati inseriti dai proprietari di sistemi che hanno fornito il consento alla condivisione con gli installatori.',
    jan: "Gen'",
    feb: "Feb'",
    mar: "Mar'",
    apr: "Apr'",
    may: "Mag'",
    jun: "Giu'",
    jul: "Lug'",
    aug: "Ago'",
    sep: "Set'",
    oct: "Ott'",
    nov: "Nov'",
    dec: "Dic'",
    ofTotal: 'del totale',
    ratings: 'Valutazioni',
    numberOfReviews: 'Numero di recensioni',
    date: 'Data',
    between0And10: 'Digitare un valore compreso tra 0 e 10',
    lessThan50: 'Il numero di caratteri deve essere inferiore a 50',
    npsBasedOnScore: `NPS di %{score} in base %{count} valutazioni`
  }
};

export default nps;
